import { render, staticRenderFns } from "./YinShunHome.vue?vue&type=template&id=00d7749b&scoped=true&"
import script from "./YinShunHome.vue?vue&type=script&lang=js&"
export * from "./YinShunHome.vue?vue&type=script&lang=js&"
import style0 from "./YinShunHome.vue?vue&type=style&index=0&id=00d7749b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7749b",
  null
  
)

export default component.exports